import React, { useCallback, useMemo } from 'react';
import { IItemForGetShortInfo, ITotalPrice } from 'types';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import MultipleSelect from './components/MultipleSelect';
import QuantityMaxLimitInput from './components/QuantityMaxLimitInput';
import style from './QuantityRegulationField.module.scss';

interface IQuantityRegulationField {
	setQuantityRegulationRestaurants: (value: string[]) => void;
	changeQuantityMaxLimit: (value: number) => void;
	quantityRegulationRestaurants: string[];
	fetchedRestaurants: IItemForGetShortInfo[];
	totalPrices: ITotalPrice[];
}

const QuantityRegulationField: React.FC<IQuantityRegulationField> = ({
	setQuantityRegulationRestaurants,
	changeQuantityMaxLimit,
	quantityRegulationRestaurants,
	fetchedRestaurants,
	totalPrices,
}) => {
	const handleRemove = useCallback(
		(id: string) => {
			const selectedItems = quantityRegulationRestaurants.filter((el) => el !== id);
			setQuantityRegulationRestaurants(selectedItems);
		},
		[setQuantityRegulationRestaurants, quantityRegulationRestaurants],
	);

	const restaurantsList = useMemo(() => {
		return quantityRegulationRestaurants.map((el) => {
			const label = fetchedRestaurants.find((rest) => rest.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [quantityRegulationRestaurants, fetchedRestaurants, handleRemove]);

	return (
		<div className={style.container} data-test="QuantityRegulationField">
			<div className={style.field}>
				<MultipleSelect
					setQuantityRegulationRestaurants={setQuantityRegulationRestaurants}
					quantityRegulationRestaurants={quantityRegulationRestaurants}
					totalPrices={totalPrices}
				/>
			</div>
			<div className={style.restaurantsList}>{restaurantsList}</div>
			<QuantityMaxLimitInput
				setQuantityMaxLimit={changeQuantityMaxLimit}
				isDisabled={!quantityRegulationRestaurants.length}
			/>
		</div>
	);
};

export default QuantityRegulationField;
